import { AnimatedNumber } from './AnimatedNumber';
import { SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from '@/constants/time';

interface AnimatedDurationProps {
    totalSeconds: number;
    willChange?: boolean;
}

export function AnimatedDuration({
    totalSeconds,
    willChange = false,
}: AnimatedDurationProps) {
    const hours = Math.floor(totalSeconds / SECONDS_IN_HOUR);
    const minutes = Math.floor(
        (totalSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE,
    );

    const minutesSuffix = minutes === 1 ? ' minute' : ' minutes';

    if (totalSeconds < SECONDS_IN_HOUR) {
        return (
            <AnimatedNumber
                value={minutes}
                suffix={minutesSuffix}
                willChange={willChange}
            />
        );
    }

    return (
        <div className="flex flex-col">
            <AnimatedNumber
                value={hours}
                suffix={hours === 1 ? ' hour' : ' hours'}
                willChange={willChange}
            />
            <AnimatedNumber
                value={minutes}
                suffix={minutesSuffix}
                willChange={willChange}
            />
        </div>
    );
}
